import React from "react";
import { SvgContainer } from "./style";
const Index = props => {
  return (
    <SvgContainer
      id="vector"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 469.33 469"
      color={props.color}
      size={props.size}
      fillColor={props.fillColor}
    >
      <path
        d="m448,106.84h-64.81l21.4,-79.81c3.05,-11.37 -3.69,-23.08 -15.08,-26.13 -11.39,-3.05 -23.11,3.71 -26.13,15.08l-24.34,90.86h-151.51l21.4,-79.81c3.05,-11.37 -3.69,-23.08 -15.08,-26.13 -11.39,-3.03 -23.08,3.71 -26.11,15.08l-24.36,90.86h-79.36c-11.78,0 -21.33,9.54 -21.33,21.33 0,11.8 9.55,21.34 21.33,21.34h67.9l-34.32,128h-76.25c-11.77,0 -21.33,9.54 -21.33,21.33s9.56,21.33 21.33,21.33h64.81l-21.4,79.81c-3.05,11.37 3.69,23.08 15.08,26.13 1.84,0.49 3.69,0.73 5.5,0.73 9.41,0 18.05,-6.27 20.59,-15.81l24.38,-90.86h151.51l-21.4,79.81c-3.05,11.37 3.69,23.08 15.09,26.13 1.83,0.49 3.69,0.73 5.52,0.73 9.41,0 18.05,-6.27 20.59,-15.81l24.36,-90.86h79.36c11.78,0 21.34,-9.54 21.34,-21.33s-9.56,-21.33 -21.34,-21.33h-67.9l34.32,-128h76.25c11.78,0 21.33,-9.54 21.33,-21.34 0,-11.8 -9.55,-21.33 -21.33,-21.33zM293.25,277.51h-151.51l34.32,-128h151.51zM293.25,277.51"
        id="path_0"
      />
    </SvgContainer>
  );
};

export default Index;
